function getProductHandleFromUrl(url) {
  if (!url) return '';
  var match = url.split('?')[0].match(/\/products\/([^/]+)/);
  return match ? match[1] : '';
}

var pristineWishlistButton = null;

function refreshQuickAddWishlistButton(container, data) {
  var wishlistBtn = container.querySelector('.quick-add-wishlist-wrapper');
  if (!wishlistBtn) return;

  var handle = data.handle || data.productHandle || getProductHandleFromUrl(data.url);
  if (!handle) return;

  if (!pristineWishlistButton) {
    pristineWishlistButton = wishlistBtn.cloneNode(true);
    pristineWishlistButton.classList.remove('wkh-button', 'wk-headless-wishlist-button', 'wk-selected');
    pristineWishlistButton.removeAttribute('data-product-handle');
    pristineWishlistButton.removeAttribute('aria-pressed');
  }

  if (wishlistBtn.dataset.productHandle === handle) return;

  var freshWishlistBtn = pristineWishlistButton.cloneNode(true);
  freshWishlistBtn.classList.add('wkh-button', 'wk-headless-wishlist-button');
  freshWishlistBtn.dataset.productHandle = handle;
  wishlistBtn.replaceWith(freshWishlistBtn);
}

function openQuickAddModal(data) {
  if (!data) return;

  var container = document.querySelector('.js-quick-add-modal');
  if (!container) return;

  var imgEl = container.querySelector('.js-quick-modal-img');
  var titleEl = container.querySelector('.js-quick-modal-title');
  var priceEl = container.querySelector('.js-quick-modal-price');
  var variantEl = container.querySelector('.js-quick-modal-variant');
  var urlEl = container.querySelector('.js-quick-modal-url');
  var addBtn = container.querySelector('.js-quick-modal-add-btn');

  var isAvailable = data.available !== false;

  if (imgEl && data.image) imgEl.src = data.image;
  if (imgEl && data.title) imgEl.alt = data.title;
  if (titleEl && data.title) titleEl.textContent = data.title;
  if (priceEl) {
    if (!isAvailable) {
      priceEl.textContent = priceEl.dataset.labelSoldOut || 'Sold out';
    } else if (data.price) {
      priceEl.innerHTML = data.price;
    }
  }
  if (variantEl) variantEl.textContent = (data.variant && data.variant !== 'Default Title') ? data.variant : '';
  if (urlEl && data.url) urlEl.href = data.url;
  if (addBtn && data.variantId) {
    addBtn.dataset.variantId = data.variantId;
    addBtn.disabled = !isAvailable;
    addBtn.dataset.available = isAvailable ? 'true' : 'false';

    var textAddToCart = addBtn.dataset.textAddToCart || 'ADD TO CART';
    var textSoldOut = addBtn.dataset.textSoldOut || 'SOLD OUT';
    addBtn.textContent = isAvailable ? textAddToCart : textSoldOut;
  }

  refreshQuickAddWishlistButton(container, data);

  if (window.closeOtherDrawers) window.closeOtherDrawers(['open-quick-modal']);
  document.body.classList.add('open-quick-modal');

  var wrapper = document.querySelector('.snippet-quick-add-drawer');
  if (wrapper) wrapper.removeAttribute('inert');
  container.setAttribute('aria-hidden', 'false');

  var isCardQuickAdd = data.trigger === 'card-quick-add' || data.source === 'card-quick-add' || data.headerBehindOverlay === true;
  if (isCardQuickAdd) {
    document.body.classList.add('quick-modal-header-behind');
  } else {
    document.body.classList.remove('quick-modal-header-behind');
  }
}

function closeQuickAddModal() {
  document.body.classList.remove('open-quick-modal', 'quick-modal-header-behind');

  var wrapper = document.querySelector('.snippet-quick-add-drawer');
  if (wrapper) wrapper.setAttribute('inert', '');

  var container = document.querySelector('.js-quick-add-modal');
  if (container) container.setAttribute('aria-hidden', 'true');
}

window.openQuickAddModal = openQuickAddModal;
window.closeQuickAddModal = closeQuickAddModal;

document.addEventListener('DOMContentLoaded', function () {
  if (window.registerDrawerCloser) window.registerDrawerCloser('open-quick-modal', closeQuickAddModal);
});
document.addEventListener('click', function (e) {
  if (e.target.closest('.js-quick-add-modal-backdrop')) {
    closeQuickAddModal();
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && document.body.classList.contains('open-quick-modal')) {
    closeQuickAddModal();
  }
});

document.addEventListener('click', function (e) {
  var addBtn = e.target.closest('.js-quick-modal-add-btn');
  if (!addBtn) return;

  e.preventDefault();
  var variantId = addBtn.dataset.variantId;
  var isAvailable = addBtn.dataset.available !== 'false';
  if (!variantId || !isAvailable) return;

  addBtn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Add to cart failed');
      return r.json();
    })
    .then(function () {
      closeQuickAddModal();
      if (typeof refreshCart === 'function') {
        refreshCart();
      }
      if (typeof openCartDrawer === 'function') {
        openCartDrawer();
      }
    })
    .catch(function (err) {
      console.error('Error adding to cart from quick modal:', err);
    })
    .finally(function () {
      addBtn.disabled = addBtn.dataset.available === 'false';
    });
});